// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { isDefined } from '@utilities';

// Import style for web component
const styles = require( './web-component-style.scss' );

// eslint-disable-next-line require-jsdoc
@customElement( 'lfm-faq-tag' )
export class FAQTag extends LitElement {
    // Define style
    static styles = css`${ unsafeCSS( styles ) }`;

    // Properties
	@property({ type: String, attribute: 'tag-id' }) tagID;

    // eslint-disable-next-line require-jsdoc
    render() {
        // Check if the tag exists
        if ( ! isDefined( this.tagID ) || ! isDefined( UOLFM_FAQ.tags ) || ! isDefined( UOLFM_FAQ.tags[ this.tagID ] ) ) {
            return;
        }

        return html`
            <div 
                class="tag"
                style="background-color: ${ this.color }"
            >
                ${ this.name }
            </div>
        `;
    }

    /**
     * Returns the tag name
     * 
     * @return {String} The name of the tag
     */
    get name() {
        return UOLFM_FAQ.tags[ this.tagID ].name;
    }

    /**
     * Returns the tag color
     * 
     * @return {String} The color of the tag
     */
    get color() {
        return UOLFM_FAQ.tags[ this.tagID ].color;
    }
}
